import { csx } from '@vtex/admin-ui'

const styles = {
  container: csx({
    width: '100%',
  }),
  radioGroup: {
    label: csx({
      paddingBottom: '$space-2',
    }),
  },
  selector: csx({
    marginTop: '$space-4',
    marginLeft: '$space-7',
  }),
  checkbox: csx({
    'div[data-wrap="true"]': {
      flexWrap: 'nowrap',
    },
    'input[type="checkbox"]': {
      minWidth: '1.25rem',
    },
  }),
  view: {
    cheapest: csx({
      marginTop: '$space-2',
      display: 'block',
    }),
    selected: csx({
      marginTop: '$space-3',
    }),
  },
}

export default styles
